module.exports = __webpack_public_path__ + "img/bg_onepack_cod.337f90f3.png";